import { Navigate, useNavigate, useParams } from 'react-router';
import { errorMessage } from '../api/client';
import { useJoinMe, useLeave } from '../api/queries';
import { Alert, FullPageSpinner } from '../components/ui';
import { usePageTitle } from '../lib/title';
import { Viewer } from '../viewer/Viewer';

export function CustomerViewerPage() {
  const { profileId } = useParams<{ profileId: string }>();
  const me = useJoinMe();
  const leave = useLeave();
  const navigate = useNavigate();
  usePageTitle(me.data?.profileName ?? '원격 지원');

  if (me.isPending) return <FullPageSpinner label="접속 정보 확인 중" />;
  if (me.isError)
    return (
      <div className="mx-auto mt-24 max-w-md px-4">
        <Alert level="error">{errorMessage(me.error)}</Alert>
      </div>
    );
  if (!me.data) return <Navigate to="/join" replace />;
  if (profileId !== me.data.profileId)
    return <Navigate to={`/support/${me.data.profileId}`} replace />;

  return (
    <div className="h-screen">
      <Viewer
        profileId={me.data.profileId}
        supportSessionId={me.data.supportSessionId}
        variant="customer"
        title={me.data.profileName}
        headerNote={`${me.data.participantLabel}님`}
        exitLabel="나가기"
        onExit={() => {
          if (!window.confirm('접속을 종료할까요? 링크나 코드로 다시 들어올 수 있습니다.')) return;
          leave.mutate(undefined, { onSettled: () => navigate('/join', { replace: true }) });
        }}
      />
    </div>
  );
}
